<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <!-- <el-input placeholder="输入名称" />
        <el-button type="primary" size="large" @click="fnPopCreate()">查询 </el-button> -->
        <el-button type="success" @click="fnSyncAllNode()">一键同步全部店铺</el-button>

      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="key_id" align="center" />
        <el-table-column label="名称" prop="key_name" align="center" />
        <el-table-column label="托乐乐应用名称" prop="node_name" align="center" />
        <el-table-column label="素质课应用名称" prop="node_3_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnEditClass(row,1)">托乐乐配置</el-button>
            <el-button type="text" @click="fnEditClass(row,3)">素质课配置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetAppList" />
    </div> -->

    <el-dialog title="应用配置" :visible.sync="bCreateReply" width="70%">
      <el-form :model="postForm" class="fn-clear">
        <el-form-item label="应用名称">
          <el-select v-model="postForm.node_id" placeholder="请选择">
            <el-option v-for="item in appLists" :key="item.app_id" :label="item.app_name" :value="item.app_id" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="fnSubmitCreate()">提交</el-button>
    </el-dialog>
  </div>

</template>
<script>

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'ShopClassList',
  data() {
    return {
      lists: [],
      tableKey: 0,
      total: 0,
      bCreateReply: false,
      appLists: [],
      postForm: {
        node_id: '',
        key_id: '',
        type: 1
      }
    }
  },
  created() {
    this.fnGetAppList()
    this.fnGetNodeList()
  },
  methods: {
    fnGetAppList: function() {
      this.$http.getAppList().then(res => {
        this.appLists = res.data
      })
    },
    fnGetNodeList: function() {
      this.bCreateReply = false
      this.$http.getNodeList().then(res => {
        this.lists = res.data
      })
    },
    fnSyncAllNode() {
      this.$http.syncNode().then(res => {
        if (res.code == 200) {
          this.$message.success('一键同步成功')
          this.fnGetNodeList()
        }
      })
    },
    fnPopCreate() {
      this.postForm.class_id = ''
      this.postForm.name = ''
      this.bCreateReply = true
    },
    fnSubmitCreate: function() {
      if (!this.postForm.node_id) {
        this.$message.error('请选择一个应用')
        return
      }
      this.$http.improveNode(this.postForm).then(res => {
        if (res.code == 200) {
          this.$message.success('更新成功')
          this.fnGetNodeList()
        }
      })
    },
    fnEditClass(app, type) {
      this.postForm.key_id = app.key_id
      if (type == 1) {
        this.postForm.node_id = app.node_id || ''
        this.postForm.type = 1;
      } else if (type==3) {
        this.postForm.node_id = app.node_id_3 || ''
        this.postForm.type = 3;
      }
      this.bCreateReply = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
